import { forwardRef, type SVGProps } from 'react'

interface ReviewsProps extends SVGProps<SVGSVGElement> {}

export const ReviewsIcon = forwardRef<SVGSVGElement, ReviewsProps>(
  (props, ref) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="currentColor"
        viewBox="0 -960 960 960"
        {...props}
      >
        <path d="m363-390 117-71 117 71-31-133 104-90-137-11-53-126-53 126-137 11 104 90zM80-80v-720q0-33 23.5-56.5T160-880h640q33 0 56.5 23.5T880-800v480q0 33-23.5 56.5T800-240H240zm126-240h594v-480H160v525zm-46 0v-480z" />
      </svg>
    )
  },
)
ReviewsIcon.displayName = 'ReviewsIcon'
